<template>
  <div id="gl_account_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="glAccountHeader" v-if="$route.params.id > 0">Update Wrong GL</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackGLAccountsList">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="glAccountForm">
                <div class="purchase-order-create-main table-responsive-sm">
                  <div class="form-row" v-if="transaction_type != ''"
                       style="margin-bottom: 1rem!important;">
                    <div class="col-md-3">
                      <div class="title">Transaction Type : {{ transaction_type }}</div>
                    </div>
                    <div class="col-md-3">
                      <div class="title">Document Number : {{ document_number }}</div>
                    </div>
                    <div class="col-md-3">
                      <div class="title">Source : {{ source }}</div>
                    </div>
                    <div class="col-md-3">
                      <div class="title">Difference : {{ diff_dr_cr }}</div>
                    </div>
                  </div>
                  <table aria-describedby="table" class="table table-sm table-bordered font-1">
                    <thead>
                    <tr class="table-primary">
                      <th scope="col" class="require" style="width:300px">GL Number</th>
                      <th scope="col">Transaction Number</th>
                      <th scope="col" style="width:300px">Reference</th>
                      <th scope="col">Module Name</th>
                      <th scope="col">Description</th>
                      <th scope="col">Debit</th>
                      <th scope="col">Credit</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                      <td>
                        <v-select v-model="row.account" name="account" id="account"
                                  label="text" :filterable="false" :options="accountsArr"
                                  @search="onSearchAccount"
                                  placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                          <template slot="no-options">
                            Search Account...
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.text }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.text }}
                            </div>
                          </template>
                        </v-select>
                        <div class="field-error">{{ row.gl_account_err_msg }}</div>
                      </td>
                      <td>
                        <input type="text" placeholder="Description" v-model="row.gl_transaction_number"
                               name="description" id="description" class="form-control"
                               :disabled="row.row_transaction_disabled">
                      </td>
                      <td>
                        <template>
                          <input type="text" placeholder="reference" v-model="row.reference" name="debit" id="debit"
                                 class="form-control" :disabled="row.row_reference_disabled">
                        </template>
                      </td>
                      <td>
                        <template>
                          <input type="text" v-model="row.module_name" name="credit" id="credit" class="form-control"
                                 :disabled="row.row_module_disabled">
                        </template>
                      </td>
                      <td>
                        <template>
                          <input type="text" v-model="row.description" name="credit" id="credit" class="form-control"
                                 :disabled="row.row_description_disabled">
                        </template>
                      </td>
                      <td>
                        <template>
                          <input type="text" placeholder="0.00" v-model="row.debit" name="debit" id="debit"
                                 class="form-control text-right"
                                 @keypress="isNumberOnly($event)"
                                 @input="onDebitInput($event,index)"
                                 :disabled="row.row_debit_disabled">
                        </template>
                        <div class="field-error">{{ row.dr_amount_err_msg }}</div>
                      </td>
                      <td>
                        <template>
                          <input type="text" placeholder="0.00" v-model="row.credit" name="credit" id="credit"
                                 class="form-control text-right"
                                 @keypress="isNumberOnly($event)"
                                 @input="onCreditInput($event,index)"
                                 :disabled="row.row_credit_disabled">
                        </template>
                        <div class="field-error">{{ row.cr_amount_err_msg }}</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="btn-groups">
                  <button type="submit" id="CreateGLAccountBtn" v-if="$route.params.id > 0" class="btn btn-primary"
                          v-on:click.prevent="CreateGLAccount">
                    <i class="fp-reload"> </i> Update
                  </button>
                  <button type="submit" id="cancelGLAccountBtn" class="btn btn-tertiary"
                          v-on:click.prevent="BackGLAccountsList">
                    <i class="fp-close"> </i> Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

export default {
  name: "GLAccountCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update GL Account | " +process.env.COPYRIGHT_NAME : "Create GL Account | " +process.env.COPYRIGHT_NAME
    }
  },

  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading: false,
    code_error_msg: "",
    description_error_msg: "",
    location_id: "",
    company: "",
    rows: [],
    accountsArr: [],
    transaction_type: '',
    document_number: '',
    source: '',
    gl_out_of_balance: '',
    transaction_number: '',
    reference: '',
    module_name: '',
    description: '',
    total_dr: 0,
    total_cr: 0,
    diff_dr_cr: 0,
    glcode: 0,
    final_total_dr: 0,
    final_total_cr: 0,
  }),
  watch: {

    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'wrong_gl_post') {
            self.cantAccessPage = true;
          }
        }
      }

    },
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
    self.loadFieldData(['accountTypes', 'location']);

    setTimeout(function () {
      var path = window.location.pathname;
      var segments = path.split("/");

      if (segments[3]) {
        self.loadGLAccount();
      }
    }, 100);
  },
  methods: {
    BackGLAccountsList() {
      var self = this;
      self.$router.push("/gl-transaction/list");
    },

    CreateGLAccount(flag) {
      var self = this;
      var error = false;

      self.final_total_dr = 0;
      self.final_total_cr = 0;
      for (var i = 0; i < self.rows.length; i++) {
        if (self.rows[i].flag == "debit") {
          self.final_total_dr += self.removeFormat(self.rows[i].debit);
        } else if (self.rows[i].flag == "credit") {
          self.final_total_cr += self.removeFormat(self.rows[i].credit);
        }

        if (self.rows[i].is_new === "true") {
          if (self.rows[i].account.value === "") {
            self.rows[i].gl_account_err_msg = 'Required Field.'
            error = true
          }

          if (self.rows[i].flag === "debit") {
            if (self.rows[i].debit === "") {
              self.rows[i].dr_amount_err_msg = 'Required Field.'
              error = true
            }
          } else if (self.rows[i].flag === "credit") {
            if (self.rows[i].credit === "") {
              self.rows[i].cr_amount_err_msg = 'Required Field.'
              error = true
            }
          } else {
            self.rows[i].dr_amount_err_msg = 'Required Field.'
            self.rows[i].cr_amount_err_msg = 'Required Field.'
            error = true
          }
        }
      }

      var path = window.location.pathname;
      var segments = path.split("/");
      var fields = $("#glAccountForm").serializeArray();

      fields.push({name: "id", value: segments[3]});
      fields.push({name: "journalItems", value: JSON.stringify(self.rows)});

      if (!error) {
        self.loading = true;
        if (self.checkTotalDrCr()) {
          $.ajax({
            url: process.env.ROOT_API + "/gl-transaction/create",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
              self.loading = false;
              if (data.status == "success") {
                self.rows = [];
                self.rows.push({
                  gl_item_id: 0,
                  gl_transaction_number: "",
                  flag: "",
                  glcode: "",
                  reference: "",
                  module_name: "",
                  debit: "",
                  credit: "",
                  account: "",
                });
                self.$router.push("/gl-transaction/list");
              }
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, false, 'glaccount-create');
            }
          });
        } else {
          self.$swal('', "Total Dr and Cr is not Equal.", 'info');
          self.final_total_dr = '';
          self.final_total_cr = '';
          self.loading = false;
        }
      }
    },

    loadGLAccount() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/gl-transaction/" + segments[3],
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;

          if (data.status == "success") {
            var glItems = data.content;
            self.rows = [];
            if (glItems[0].transaction_type != null) {
              self.transaction_type = glItems[0].transaction_type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              self.document_number = glItems[0].document_number;
              self.source = glItems[0].source;
              self.gl_out_of_balance = glItems[0].gl_out_of_balance;
              self.transaction_number = glItems[0].transaction_number;
              self.reference = glItems[0].reference;
              self.module_name = glItems[0].module_name;
              self.description = glItems[0].description;
              self.glcode = glItems[0].glcode;
            }

            for (var i = 0; i < glItems.length; i++) {
              if (glItems[i].flag === "debit") {
                self.total_dr += self.removeFormat(glItems[i].debit)
              }

              if (glItems[i].flag === "credit") {
                self.total_cr += self.removeFormat(glItems[i].credit)
              }

              self.diff_dr_cr = Math.abs(parseFloat((self.total_dr - self.total_cr).toFixed(2)));
              self.rows.push({
                gl_item_id: glItems[i].gl_item_id,
                gl_transaction_number: glItems[i].transaction_number,
                flag: glItems[i].flag,
                glcode: glItems[i].glcode,
                reference: glItems[i].reference,
                module_name: glItems[i].module_name,
                debit: glItems[i].debit,
                credit: glItems[i].credit,
                description: glItems[i].description,
                account: {
                  text: glItems[i].account_code_description,
                  value: glItems[i].account_id
                },
                row_transaction_disabled: true,
                row_reference_disabled: true,
                row_module_disabled: true,
                row_description_disabled: true,
                row_debit_disabled: true,
                row_credit_disabled: true,
                is_new: "false",
                gl_account_err_msg: '',
                dr_amount_err_msg: '',
                cr_amount_err_msg: '',
              });
            }
            self.addNewRow();
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'glaccount-details');
        }
      });
    },

    addNewRow() {
      var self = this;
      if (self.gl_out_of_balance === "true" && self.diff_dr_cr !== 0) {
        self.rows.push({
          gl_item_id: null,
          gl_transaction_number: self.transaction_number,
          flag: "",
          glcode: self.glcode,
          reference: self.reference,
          module_name: self.module_name,
          debit: "",
          credit: "",
          description: self.description,
          account: {
            text: "",
            value: ""
          },
          row_transaction_disabled: true,
          row_reference_disabled: true,
          row_module_disabled: true,
          row_description_disabled: true,
          row_debit_disabled: false,
          row_credit_disabled: false,
          is_new: "true",
          gl_account_err_msg: '',
          dr_amount_err_msg: '',
          cr_amount_err_msg: '',
        });
      }
    },

    onSearchAccount(search, loading) {
      var self = this;
      if (search.length > 3) {
        loading(true);
        self.searchField(loading, search, 'accounts', '');
      }
    },

    isNumberOnly: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46
          || evt.target.value.indexOf('.') != -1) && (charCode !== 45 || evt.target.value.indexOf('-') != -1)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    onDebitInput($event, index) {
      var self = this;
      if (self.rows[index].debit.trim() == "") {
        self.rows[index].row_debit_disabled = false;
        self.rows[index].row_credit_disabled = false;
        self.rows[index].dr_amount_err_msg = ''
        self.rows[index].cr_amount_err_msg = ''
        self.rows[index].flag = "";
      } else {
        self.rows[index].row_credit_disabled = true;
        self.rows[index].flag = "debit";
        self.rows[index].dr_amount_err_msg = ''
        self.rows[index].cr_amount_err_msg = ''
      }
    },

    onCreditInput($event, index) {
      var self = this;
      if (self.rows[index].credit.trim() == "") {
        self.rows[index].row_debit_disabled = false;
        self.rows[index].row_credit_disabled = false;
        self.rows[index].dr_amount_err_msg = ''
        self.rows[index].cr_amount_err_msg = ''
        self.rows[index].flag = "";
      } else {
        self.rows[index].row_debit_disabled = true;
        self.rows[index].flag = "credit";
        self.rows[index].dr_amount_err_msg = ''
        self.rows[index].cr_amount_err_msg = ''
      }
    },

    checkTotalDrCr() {
      var self = this;
      return (self.final_total_dr - self.final_total_cr).toFixed(2) == 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/accounting/GLTransactionUpdate.vue